/*
    This file encloses the apiFetcher util with implementation
    for loading animation and custom answers.
    Used for back compatibility with older API versions
*/

import { useState } from 'react';
import LoadingSpinner from 'contexts/loading-spinner/loading-spinner';
import { useApiFetcher } from 'utils/fetcher/ApiFetcher';
import useAuth from 'hooks/useAuth';






export const useApiGeneric = () => {
    const { logout } = useAuth();
    const ApiFetcher = useApiFetcher();
    const [isLoading, setIsLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("Cargando información");

    

    //-------------------------------------
    const fetchAPI = async ({
        section, 
        action, 
        params, 
        OnLoaded,
        loadingMessage = "Cargando información",
        showSuccessNotification= false,
        showErrorNotification= false,
        showSuccessNotificationModal = false,
        showErrorNotificationModal = true
    }) => {
        setLoadingText(loadingMessage);
        setIsLoading(true);

        // Iterate through params and append all values to formData
        const formData = new FormData();
        if (params) {
            Object.entries(params).forEach(([key, value]) => {
                console.log("Appending to FormData:", key, value);
                if (typeof value === 'object' && value !== null && !(value instanceof File) && !(value instanceof Blob)) {
                    // Serialize objects to JSON
                    formData.append(key, JSON.stringify(value));
                } else {
                    // Append primitive values directly
                    formData.append(key, value);
                }
            });
        }

        await ApiFetcher({
            type: 'POST',
            url: "?section="+section+"&action="+action,
            cache: 'no-store',
            data: formData,
            showSuccessNotification,
            showErrorNotification,
            showSuccessNotificationModal,
            showErrorNotificationModal,
            onSuccess: (payload)=>{
                setIsLoading(false);
                let success = true;
                if(payload.code && payload.code !== 0) {
                    success = false;
                }

                if(OnLoaded) {
                    OnLoaded(success, payload);
                }
                return true;
            },
            onError: (responseData)=>{
                console.warn("API error:", responseData);
                setIsLoading(false);

                if(responseData === 'LOGOUT') {
                    // Si la respuesta es 'LOGOUT', llamar al logout del contexto de autenticación
                    logout();
                    return false;
                }

                if (OnLoaded) {
                    OnLoaded(false, responseData);
                }

                return false;
            },
        });
    }







    //-------------------------------------
    const LoadingAnimation = () => {
        return (<>
            {isLoading && <LoadingSpinner text={loadingText} bgOpacity={0.0}/>}
        </>);
    }

    return {
        fetchAPI,
        LoadingAnimation
    }
};
